import React from 'react';
import RelatedArticleProps from './props';
import styles from './style.module.scss';

const RelatedArticle = ({ title, link, image, imageAlt, category }: RelatedArticleProps) => {
  return (
    <div className={styles.relatedArticle}>
      <a href={link} title={title}>
        <img src={image} alt={imageAlt} />
        <div className={styles.content}>
          <h4>{category}</h4>
          <h3>{title}</h3>
        </div>
      </a>
    </div>
  );
};

export default RelatedArticle;
